import {
    getUser,
    listUsers
} from './queries';
import {
    createUser,
    deleteUser,
    updateUser,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreateUser,
    DeleteUser,
    GetUser,
    ListUsers,
    UpdateUser,
    User
} from "../types.ts";

import {generateClient} from 'aws-amplify/api';
import {usersApiConfig} from "../config/flexinet-users-api.ts";

const normalizeFilter = (filter: { [key: string]: string }) => {
    return Object.keys(filter)
                 .reduce((acc: { [key: string]: string }, key: string) => {
                     if (filter[key] !== '' && filter[key] !== undefined) {
                         acc[key] = filter[key];
                     }
                     return acc;
                 }, {});

};

const client = generateClient({
                                  endpoint: usersApiConfig.endpoint,
                                  authMode: 'userPool'
                              });

export const fetchRecords = async (filter?: { [key: string]: string }) => {
    let transformedFilter = {};
    if (typeof filter !== 'undefined') {
        transformedFilter = normalizeFilter(filter);
    }

    const response = await client.graphql<GraphQLQuery<ListUsers>>({
                                                                       query: listUsers,
                                                                       variables: {filter: transformedFilter},
                                                                   });
    const items = response.data?.listUsers.items || [];
    return items.map(item => ({...item, id: item.username || item.sub || ''}));
};

export const fetch = async (username: string) => {
    const response = await client.graphql<GraphQLQuery<GetUser>>({
                                                                     query: getUser,
                                                                     variables: {username: username},
                                                                 });
    const user = response.data?.getUser;
    return user ? {...user, id: user.username || user.sub || ''} : undefined;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateUser>>({
                                                                        query: createUser,
                                                                        variables: {input: payload},
                                                                    });
    return response.data?.createUser;
};

export const update = async (_username: string, record: User) => {
    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateUser>>({
                                                                        query: (updateUser),
                                                                        variables: {input: record},
                                                                    });
    return response.data?.updateUser;
};

export const deleteRecord = async (username: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteUser>>({
                                                                        query: (deleteUser),
                                                                        variables: {input: {username: username}},
                                                                    });
    return response.data?.deleteUser;
};
